import { GiftCardConfirmation } from './GiftCardConfirmation';
export default GiftCardConfirmation;
